// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_jB","credits":"e_kB","badgeContainer":"e_lB","badge":"e_mB"};